/* eslint-disable class-methods-use-this */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

const propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node,
};

const defaultProps = {
  show: Boolean(false),
};

function initDialog() {
  const el = document.createElement('div');
  document.body.appendChild(el);
  return el;
}

class Overlay extends Component {
  state = {
    root: initDialog(),
  };

  componentDidMount() {
    ReactDOM.render(this.renderDialog(), this.state.root);
  }

  componentDidUpdate() {
    ReactDOM.render(this.renderDialog(), this.state.root);
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.state.root);
    document.body.removeChild(this.state.root);
  }

  renderDialog() {
    const { show, children } = this.props;
    const display = show === Boolean(true) ? 'block' : 'none';

    const dialogStyle = {
      display,
      position: 'fixed',
      height: '100%',
      width: '100%',
      top: '0px',
      left: '0px',
      opacity: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.541176)',
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      willChange: 'opacity',
      transform: 'translateZ(0px)',
      transition:
        'left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      zIndex: 1500,
    };

    const theme = createMuiTheme({
      palette: {
        primary: blue,
      },
      typography: {
        useNextVariants: true,
        suppressDeprecationWarnings: false,
      },
    });

    return (
      <MuiThemeProvider theme={theme}>
        <div className="overlay" style={dialogStyle}>
          {children}
        </div>
      </MuiThemeProvider>
    );
  }

  render() {
    return null;
  }
}

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

export default Overlay;



// WEBPACK FOOTER //
// ./src/views/components/dialog/Overlay.js